'use strict';

require('core-js/modules/es6.array.find');

require('core-js/modules/es6.array.is-array');

require('core-js/modules/es6.array.for-each');

require('core-js/modules/es6.string.starts-with');

require('core-js/modules/es6.map');

require('core-js/modules/es6.promise');

require('linksoft-albatros/src/plugins/dropdown');

require('linksoft-albatros/src/plugins/sticky');

require('./app/main');

require('./app/modules/min-max-setting');

require('./app/modules/offlineBox');

require('./app/watchdog');

require('./app/user');

require('./app/editor');

require('./app/comissionStockDt');

require('./app/dt-control-buttons');

var _tableTemplates = require('./app/table-templates');

var _tableTemplates2 = _interopRequireDefault(_tableTemplates);

var _initializers = require('./app/initializers');

var _initializers2 = _interopRequireDefault(_initializers);

var _store = require('./app/store');

var _store2 = _interopRequireDefault(_store);

var _store3 = require('linksoft/core/store');

var _store4 = _interopRequireDefault(_store3);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _initialize = require('linksoft/core/initialize');

var _initialize2 = _interopRequireDefault(_initialize);

var _localize = require('linksoft/core/localize');

var _urls = require('./app/urls');

require('./app/components');

var _reducers = require('linksoft/core/reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _reducer = require('./app/cart/reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = require('./app/facets/reducer');

var _reducer4 = _interopRequireDefault(_reducer3);

var _linksoftReact = require('linksoft-react');

var _linksoftReact2 = _interopRequireDefault(_linksoftReact);

require('linksoft/initializers/cookie-value');

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import ls from 'linksoft';
var log = require('debug')('app:startup'); // This is entry point for building single output 'main.js' (except vendor libs defined in 'Gulp/vendors.js')

// polyfills


// Load all React.js components/containers


// register reducers before creating store


_reducers2.default.add('cart', _reducer2.default);

_reducers2.default.add('facets', _reducer4.default);

// register all required initializers
_initialize2.default.registerAll(_initializers2.default);

_initialize2.default.register(_linksoftReact2.default.finalizer, true);

(0, _jquery2.default)(document).on('loaded.bs.modal', function (e) {
    log('modal content loaded %o', e.target);
    _initialize2.default.trigger(e.target);
});

// trigger first initialization.
(0, _jquery2.default)(function () {
    // create app state store
    _store4.default.set((0, _store2.default)());
    _linksoftAlbatros.settings.initFromHiddenField('settings');

    (0, _tableTemplates2.default)();

    (0, _localize.loadLocale)().then(function () {
        (0, _urls.initUrls)();
        _initialize2.default.trigger();
    });

    // $(document).on('click', 'a[href="#"]', function (e) {
    //     e.preventDefault();
    // });

    var CarouselHoverClassName = 'carousel__item--hovered';

    // let fliped items open after click
    (0, _jquery2.default)(document).on('click', '.carousel__item', function () {
        (0, _jquery2.default)('.carousel__item').removeClass(CarouselHoverClassName);
        (0, _jquery2.default)(this).addClass(CarouselHoverClassName);
    });

    // close flipped item
    (0, _jquery2.default)(document).on('click', function (e) {
        var $target = (0, _jquery2.default)(e.target);
        var clickOnTrigger = $target.hasClass('carousel__item');
        var clickOnContent = $target.closest('.carousel__item').length > 0;

        if (clickOnContent || clickOnTrigger) return;

        (0, _jquery2.default)('.carousel__item').removeClass(CarouselHoverClassName);
    });

    (0, _jquery2.default)(document).on('click', '#show-filters-mobile', function () {

        (0, _jquery2.default)(this).toggleClass('btn-orange');

        (0, _jquery2.default)(this).next().toggleClass('open').slideToggle();

        if ((0, _jquery2.default)(this).next().hasClass('open')) {
            (0, _jquery2.default)(this).find('.text').html((0, _jquery2.default)(this).attr('data-text-close'));
        } else {
            (0, _jquery2.default)(this).find('.text').html((0, _jquery2.default)(this).attr('data-text-open'));
        }
    });

    // for menu in mobile
    (0, _jquery2.default)(document).on('click', '.navbar-toggle', function () {
        (0, _jquery2.default)(this).toggleClass('open');
        (0, _jquery2.default)('.navbar-collapse').toggleClass('open');
    });
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/app.js
// module id = 0
// module chunks = 0